// src/components/PropertyFormSections/OfficeDetails.js
import React from 'react';

const OfficeDetails = ({ formData, handleInputChange }) => {
    return (
        <div className="mb-4 p-3 bg-blue-50 rounded border border-blue-200">
            <h4 className="font-bold text-blue-700 mb-2">🏢 Office/Commercial Details</h4>

            {/* Floor & Chargeable Area */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Floor</label>
                    <input
                        type="text"
                        name="floor"
                        value={formData.floor || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 7th"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Chargeable Area (sq ft)</label>
                    <input
                        type="text"
                        name="chargeable_area"
                        value={formData.chargeable_area || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 13723"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Carpet Efficiency */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Carpet Efficiency (%)</label>
                    <input
                        type="number"
                        name="carpet_efficiency"
                        value={formData.carpet_efficiency || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 60"
                        className="border p-2 w-full text-sm"
                        min="0"
                        max="100"
                    />
                </div>
                <div>
                    <label className="block text-sm">Interior Condition</label>
                    <select
                        name="interior_condition"
                        value={formData.interior_condition || ''}
                        onChange={handleInputChange}
                        className="border p-2 w-full text-sm"
                    >
                        <option value="">Select</option>
                        <option value="Furnished">Furnished</option>
                        <option value="Bare Shell">Bare Shell</option>
                        <option value="Warm Shell">Warm Shell</option>
                        <option value="Semi-Furnished">Semi-Furnished</option>
                    </select>
                </div>
            </div>

            {/* Height Details */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Floor to Floor Height</label>
                    <input
                        type="text"
                        name="floor_to_floor_height"
                        value={formData.floor_to_floor_height || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 13.7 ft"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Floor to Ceiling Height</label>
                    <input
                        type="text"
                        name="floor_to_ceiling_height"
                        value={formData.floor_to_ceiling_height || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 12.30 ft"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Commercial Terms */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Rent per sq ft/month</label>
                    <input
                        type="text"
                        name="rent_per_sqft"
                        value={formData.rent_per_sqft || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., ₹200"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">CAM Charges</label>
                    <input
                        type="text"
                        name="cam_charges"
                        value={formData.cam_charges || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Included or ₹25"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Security Deposit</label>
                    <input
                        type="text"
                        name="security_deposit"
                        value={formData.security_deposit || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 6 Months"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Security Deposit Terms</label>
                    <input
                        type="text"
                        name="security_deposit_terms"
                        value={formData.security_deposit_terms || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 12 months"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Rent Free Period</label>
                    <input
                        type="text"
                        name="rent_free_period"
                        value={formData.rent_free_period || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 45 days"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Rent Escalation</label>
                    <input
                        type="text"
                        name="rent_escalation"
                        value={formData.rent_escalation || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 5% every year"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Lock-in Period</label>
                    <input
                        type="text"
                        name="lock_in_period"
                        value={formData.lock_in_period || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 5 years"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Notice Period</label>
                    <input
                        type="text"
                        name="notice_period"
                        value={formData.notice_period || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 6 months"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Parking Details */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Parking Details</label>
                    <input
                        type="text"
                        name="parking_details"
                        value={formData.parking_details || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Included (08)"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Additional Parking Cost</label>
                    <input
                        type="text"
                        name="additional_parking_cost"
                        value={formData.additional_parking_cost || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 7500 INR/month"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Location Amenities */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Nearest Metro</label>
                    <input
                        type="text"
                        name="nearest_metro"
                        value={formData.nearest_metro || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Chakala Metro stn (0.45Km)"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Distance Airport T-1</label>
                    <input
                        type="text"
                        name="distance_airport_t1"
                        value={formData.distance_airport_t1 || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 4.6 km"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Distance Airport T-2</label>
                    <input
                        type="text"
                        name="distance_airport_t2"
                        value={formData.distance_airport_t2 || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 2.2 Km"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Nearest Hospital</label>
                    <input
                        type="text"
                        name="nearest_hospital"
                        value={formData.nearest_hospital || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Mukund Hospital (0.2 km)"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Nearest Police Station</label>
                    <input
                        type="text"
                        name="nearest_police_station"
                        value={formData.nearest_police_station || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., MIDC police Station (1.2 km)"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Nearest Fire Station</label>
                    <input
                        type="text"
                        name="nearest_fire_station"
                        value={formData.nearest_fire_station || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., Marol fire Station (1.4 km)"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Legal & Registration */}
            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">Stamp Duty</label>
                    <input
                        type="text"
                        name="stamp_duty"
                        value={formData.stamp_duty || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 0.5%"
                        className="border p-2 w-full text-sm"
                    />
                </div>
                <div>
                    <label className="block text-sm">Registration Details</label>
                    <input
                        type="text"
                        name="registration_details"
                        value={formData.registration_details || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 100% licencee"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div>
                    <label className="block text-sm">OC Status</label>
                    <select
                        name="occupancy_certificate"
                        value={formData.occupancy_certificate || ''}
                        onChange={handleInputChange}
                        className="border p-2 w-full text-sm"
                    >
                        <option value="">Select</option>
                        <option value="Received">Received</option>
                        <option value="Pending">Pending</option>
                        <option value="N/A">N/A</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm">Handover Date</label>
                    <input
                        type="text"
                        name="handover_date"
                        value={formData.handover_date || ''}
                        onChange={handleInputChange}
                        placeholder="e.g., 15th May 2026"
                        className="border p-2 w-full text-sm"
                    />
                </div>
            </div>

            {/* Special Conditions */}
            <div className="grid grid-cols-2 gap-2 mt-2">
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="tenant_fitout_allowed"
                        checked={formData.tenant_fitout_allowed !== false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    Tenant Fitout Allowed
                </label>
                <label className="flex items-center text-sm">
                    <input
                        type="checkbox"
                        name="gst_applicable"
                        checked={formData.gst_applicable !== false}
                        onChange={handleInputChange}
                        className="mr-1"
                    />
                    GST Applicable
                </label>
            </div>
        </div>
    );
};

export default OfficeDetails;